import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex justify-space-between align-items-center py-1" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-small"
}
const _hoisted_6 = { class: "d-flex justify-content-center" }

import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import Infor from '../../../api/v2/models/information'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import Information from '../../../api/v2/models/information'
import InformationView from '../atoms_molecules/InformationView.vue'
import { ROUTER_NAME } from '../../router'
import { userState } from '../../stores/user'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'InforList',
  setup(__props) {

const router = useRouter()

// Get component instance for $el access
const instance = getCurrentInstance()

// Reactive state
const infors = ref<Infor[]>([])
const page = ref(0)
const isEnd = ref(false)
const loading = ref(false)

// Breadcrumbs
const breadcrumbs = [
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: 'お知らせ一覧',
    disabled: false,
    exact: true,
    to: '/classroom/infors'
  }
]

// Computed properties
const user = computed(() => {
  return userState.user
})

// Methods
const handleScroll = (e: Event) => {
  const el = instance?.proxy?.$el as HTMLElement
  if (el && el.clientHeight + el.scrollTop >= el.scrollHeight) {
    loadInfors(true)
  }
}

const loadInfors = async (loadMore = false) => {
  if (loading.value) {
    return
  }

  if (!loadMore) {
    page.value = 0
    infors.value = []
    isEnd.value = false
  } else {
    if (isEnd.value) {
      return
    }
    page.value += 1
  }
  try {
    loading.value = true

    const more = await api.infor.index(page.value)
    infors.value = [...infors.value, ...more]

    if (more.length < 20) {
      isEnd.value = true
    }
  } finally {
    loading.value = false
  }
}

const readAll = async () => {
  await api.infor.readAll()
  loadInfors(false)
}

const toInfo = (info: Information) => {
  router.push({
    name: ROUTER_NAME.INFOR_DETAIL,
    params: {
      inforId: info.id.toString()
    }
  })
}

// Lifecycle
onMounted(() => {
  headerState.setTitle('お知らせ一覧')
  footerState.setFooterDefault()
  window.addEventListener('scroll', handleScroll)
  loadInfors()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: 'お知らせ一覧' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      (loading.value || infors.value.length > 0)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            lg: "12",
            class: "pt-3 bg-white ps-3 pe-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-large font-bold" }, " お知らせ ", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_4, [
                  (user.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 未読: " + _toDisplayString(user.value.unreadInformationsCount) + "件 ", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: "text-small ms-2 border-default p-1 text-blue cursor-pointer",
                    onClick: readAll
                  }, " すべて既読にする ")
                ])
              ]),
              _createVNode(_component_v_divider),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infors.value, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `item-${item.id}`
                }, [
                  _createVNode(InformationView, {
                    item: item,
                    onClick: ($event: any) => (toInfo(item))
                  }, null, 8 /* PROPS */, ["item", "onClick"]),
                  _createVNode(_component_v_divider)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */)),
              _createElementVNode("div", _hoisted_6, [
                (loading.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      color: "green",
                      class: "loading"
                    }))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" お知らせがありません ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }))
    ])
  ]))
}
}

})